<template lang="pug">
.photoswipe-gallery
    slot
</template>

<script>
import PhotoSwipeLightbox from 'photoswipe/dist/photoswipe-lightbox.esm.js';
import PhotoSwipe from 'photoswipe/dist/photoswipe.esm.js';
import 'photoswipe/dist/photoswipe.css';

export default {
    name: 'PhotoSwipeGallery',
    props: {
        images: {
            type: Array,
            required: true,
            // Expected format: [{ src: String, width: Number, height: Number, alt: String, thumbnail: String }]
        },
        index: {
            type: Number,
            default: 0
        },
        open: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            lightbox: null
        };
    },
    watch: {
        open(newVal) {
            if (newVal) {
                this.openGallery();
            }
        }
    },
    methods: {
        openGallery() {
            if (!this.images || this.images.length === 0) return;

            // Create data source from images prop
            const dataSource = this.images.map(img => ({
                src: img.src,
                width: img.width || 1200,
                height: img.height || 800,
                alt: img.alt || '',
                downloadUrl: img.downloadUrl || null
            }));

            // Create and open lightbox
            this.lightbox = new PhotoSwipeLightbox({
                dataSource,
                showHideAnimationType: 'zoom',
                pswpModule: PhotoSwipe,
                // UI options
                closeTitle: 'Schließen',
                zoomTitle: 'Zoom',
                arrowPrevTitle: 'Zurück',
                arrowNextTitle: 'Weiter',
                // Behavior
                wheelToZoom: true,
                pinchToClose: true,
                closeOnVerticalDrag: true,
                // Padding
                paddingFn: () => ({ top: 30, bottom: 30, left: 20, right: 20 })
            });

            // A download button in the top bar, PhotoSwipe's own way of adding
            // one (ui.registerElement): shown when the images carry a
            // downloadUrl, pointed at the current image on every change.
            if (dataSource.some(img => img.downloadUrl)) {
                this.lightbox.on('uiRegister', () => {
                    this.lightbox.pswp.ui.registerElement({
                        name: 'download-button',
                        order: 8,
                        isButton: true,
                        tagName: 'a',
                        html: {
                            isCustomSVG: true,
                            inner: '<path d="M20.5 14.3 17.1 18V10h-2.2v8l-3.4-3.7L10 15.9l6 6.1 6-6.1ZM23 23H9v2h14Z" id="pswp__icn-download"/>',
                            outlineID: 'pswp__icn-download'
                        },
                        onInit: (element, pswp) => {
                            element.setAttribute('title', 'Herunterladen');
                            element.setAttribute('rel', 'noopener');
                            pswp.on('change', () => {
                                const url = pswp.currSlide.data.downloadUrl;
                                element.href = url || '#';
                                element.style.display = url ? '' : 'none';
                            });
                        }
                    });
                });
            }

            this.lightbox.on('close', () => {
                this.$emit('close');
                this.$emit('update:open', false);
            });

            this.lightbox.on('change', () => {
                const currentIndex = this.lightbox.pswp.currIndex;
                this.$emit('update:index', currentIndex);
            });

            this.lightbox.init();
            this.lightbox.loadAndOpen(this.index);
        },
        close() {
            if (this.lightbox && this.lightbox.pswp) {
                this.lightbox.pswp.close();
            }
        }
    },
    beforeDestroy() {
        if (this.lightbox) {
            this.lightbox.destroy();
            this.lightbox = null;
        }
    }
};
</script>

<style lang="sass">
// PhotoSwipe customizations (not scoped to allow styling the lightbox)
.pswp
    --pswp-bg: rgba(0, 0, 0, 0.9)

    // Navigation arrows
    .pswp__button--arrow
        background: none
        &::before
            background-color: rgba(255, 255, 255, 0.9)

    // Close button
    .pswp__button--close
        background: none

    // Counter
    .pswp__counter
        font-size: 14px
        opacity: 0.8
</style>
